// ===== 01-header.js =====
/* 01-header: mobile section menu (2026-09-06). Opens a sheet of in-page anchors;
   closes on link tap, scrim tap, Escape, or when the viewport grows to desktop.
   The smooth-scroll handler in build.py (SMOOTH_JS) handles the actual jump. */
(function () {
  var header = document.getElementById('lp-header');
  if (!header) return;
  var btn = header.querySelector('.hd-burger');
  var sheet = header.querySelector('.hd-sheet');
  var scrim = header.querySelector('.hd-scrim');
  if (!btn || !sheet || !scrim) return;

  function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }
  function setOpen(on) {
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Close menu' : 'Open menu');
    sheet.hidden = !on;
    scrim.hidden = !on;
    header.classList.toggle('is-menu-open', on);
    try { if (window.clarity) window.clarity('event', on ? 'menu_open' : 'menu_close'); } catch (e) {}
  }

  btn.addEventListener('click', function () { setOpen(!isOpen()); });
  scrim.addEventListener('click', function () { setOpen(false); });
  sheet.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (a) {
      try { if (window.clarity) window.clarity('event', 'menu_' + (a.getAttribute('href') || '').replace('#lp-', '')); } catch (err) {}
      setOpen(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); }
  });
  if (window.matchMedia) {
    var mq = window.matchMedia('(min-width: 768px)');
    var onChange = function (ev) { if (ev.matches && isOpen()) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();


// ===== 02-hero.js =====
/* 02-hero: pause the badge marquee while the hero is off-screen (perf only, no visual effect) */
(function () {
  var track = document.querySelector('#lp-hero .hr-track');
  if (!track) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        track.style.animationPlayState = entries[i].isIntersecting ? 'running' : 'paused';
      }
    },
    { threshold: 0 }
  );
  io.observe(track.closest('#lp-hero .hr-badges') || track);
})();


// ===== 05-reason3.js =====
/* 05-reason3: Brain Scans / Attention Test tab switcher.
   Swaps the red chart card AND the text column + fine print together.
   Vanilla JS, scoped to #lp-reason3. Zero layout shift (CSS grid-stacked panes). */
(function () {
  var section = document.getElementById('lp-reason3');
  if (!section) return;

  var tabs = Array.prototype.slice.call(section.querySelectorAll('.r3-tab'));
  var panes = Array.prototype.slice.call(section.querySelectorAll('[data-r3-pane]'));
  if (!tabs.length) return;

  function activate(state, moveFocus) {
    section.setAttribute('data-r3-state', state);
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-r3-tab') === state;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && moveFocus) tab.focus();
    });
    panes.forEach(function (pane) {
      pane.setAttribute('aria-hidden', pane.getAttribute('data-r3-pane') === state ? 'false' : 'true');
    });
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      activate(tab.getAttribute('data-r3-tab'), false);
    });
    tab.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      else if (e.key === 'Home') dir = -i || 0;
      else if (e.key === 'End') dir = tabs.length - 1 - i;
      else return;
      e.preventDefault();
      var next = tabs[(i + dir + tabs.length) % tabs.length];
      activate(next.getAttribute('data-r3-tab'), true);
    });
  });
})();


// ===== 10-buy.js =====
/* 10 · BUY / OFFER · product-card tabs (The Pill / What's Inside / How to Use It / Why Deadline) */
(function () {
  var root = document.getElementById('lp-buy');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('.by-tab'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('.by-panel'));
  var capTitle = root.querySelector('.by-caption-title');
  var capDesc = root.querySelector('.by-caption-desc');
  if (!tabs.length || tabs.length !== panels.length) return;

  function activate(index, moveFocus) {
    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (panel, i) {
      var on = i === index;
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    var active = panels[index];
    if (capTitle && active.getAttribute('data-title')) {
      capTitle.textContent = active.getAttribute('data-title');
    }
    if (capDesc && active.getAttribute('data-desc')) {
      capDesc.textContent = active.getAttribute('data-desc');
    }
    if (moveFocus) tabs[index].focus();
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      activate(i, false);
    });
    tab.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      else if (e.key === 'Home') { e.preventDefault(); activate(0, true); return; }
      else if (e.key === 'End') { e.preventDefault(); activate(tabs.length - 1, true); return; }
      if (!dir) return;
      e.preventDefault();
      activate((i + dir + tabs.length) % tabs.length, true);
    });
  });
})();


// ===== 11-beta.js =====
/* 11-beta : testimonial marquee (46s linear loop, pause on hover/drag,
   drag to scrub, prefers-reduced-motion honored).
   A pure-CSS keyframe fallback runs without JS; this script takes over
   (section gets [data-bt-js]) to add drag support and seamless resume. */
(function () {
  var section = document.getElementById('lp-beta');
  if (!section) return;

  var DURATION = 46; // seconds per full set cycle (live dl-beta pattern)
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var rows = [].slice.call(section.querySelectorAll('[data-bt-row]'));
  if (!rows.length) return;

  section.setAttribute('data-bt-js', '');

  var states = rows.map(function (row) {
    return {
      row: row,
      track: row.querySelector('[data-bt-track]'),
      set: row.querySelector('.bt-set'),
      phase: parseFloat(row.getAttribute('data-bt-phase')) || 0,
      offset: 0,
      period: 0,
      speed: 0,
      hovered: false,
      dragging: false,
      dragStartX: 0,
      dragStartOffset: 0,
      measured: false
    };
  });

  function measure(s) {
    if (!s.row.offsetParent) { s.measured = false; return; } // display:none row
    var gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
    var w = s.set.offsetWidth + gap;
    if (w <= 0) { s.measured = false; return; }
    if (!s.measured || Math.abs(w - s.period) > 0.5) {
      s.period = w;
      s.speed = w / DURATION;
      s.offset = ((s.phase % w) + w) % w;
      s.measured = true;
      apply(s);
    }
  }

  function apply(s) {
    s.track.style.transform = 'translateX(' + (-s.offset).toFixed(2) + 'px)';
  }

  function measureAll() { states.forEach(measure); }

  // hover pause (mouse only) + drag scrub
  states.forEach(function (s) {
    s.row.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') s.hovered = true;
    });
    s.row.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') s.hovered = false;
    });
    s.row.addEventListener('pointerdown', function (e) {
      if (!s.measured) return;
      s.dragging = true;
      s.dragStartX = e.clientX;
      s.dragStartOffset = s.offset;
      s.row.classList.add('is-dragging');
      if (s.row.setPointerCapture) {
        try { s.row.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    s.row.addEventListener('pointermove', function (e) {
      if (!s.dragging) return;
      var dx = e.clientX - s.dragStartX;
      s.offset = (((s.dragStartOffset - dx) % s.period) + s.period) % s.period;
      apply(s);
    });
    function endDrag() {
      if (!s.dragging) return;
      s.dragging = false;
      s.row.classList.remove('is-dragging');
    }
    s.row.addEventListener('pointerup', endDrag);
    s.row.addEventListener('pointercancel', endDrag);
    // block card text selection side effects while scrubbing
    s.row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  var last = null;
  function tick(now) {
    if (last === null) last = now;
    var dt = Math.min((now - last) / 1000, 0.1);
    last = now;
    if (!reduced.matches) {
      states.forEach(function (s) {
        if (!s.measured || s.hovered || s.dragging) return;
        s.offset = (s.offset + s.speed * dt) % s.period;
        apply(s);
      });
    }
    if (running) requestAnimationFrame(tick);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureAll, 120);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureAll);

  measureAll();

  /* perf: only animate while the section is on screen (visually identical,
     saves continuous main-thread work during the rest of the page) */
  var running = false;
  function start() {
    if (running) return;
    running = true;
    last = null;
    requestAnimationFrame(tick);
  }
  function stop() { running = false; }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { rootMargin: '100px' }).observe(section);
  } else {
    start();
  }
})();


// ===== 15-faq.js =====
/* 15-faq: accordion behavior. One item open at a time; first item open by default (is-open in markup). */
(function () {
  var root = document.getElementById('lp-faq');
  if (!root) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('.fq-item'));
  items.forEach(function (item) {
    var btn = item.querySelector('.fq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      items.forEach(function (other) {
        other.classList.remove('is-open');
        var b = other.querySelector('.fq-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();


// ===== 17-sticky.js =====
// 2026-08-13: mobile sticky CTA (shows on sections without a buy button)
// 2026-09-06: watches the hero CTA block, not the whole hero, so the bar returns as soon as the button scrolls off
(function () {
  var bar = document.getElementById('lp-sticky');
  if (!bar || !('IntersectionObserver' in window)) return;
  var vis = {};
  var targets = ['lp-hero-cta', 'lp-buy', 'lp-guarantee']
    .map(function (id) { return document.getElementById(id); })
    .filter(Boolean);
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { vis[e.target.id] = e.isIntersecting; });
    var block = Object.keys(vis).some(function (k) { return vis[k]; });
    bar.classList.toggle('is-on', !block);
    bar.setAttribute('aria-hidden', block ? 'true' : 'false');
    var link = bar.querySelector('a');
    if (link) link.tabIndex = block ? -1 : 0;
  }, { threshold: 0.05 });
  targets.forEach(function (t) { io.observe(t); });
})();


document.querySelectorAll('#dl-proof a[href^="#lp-"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var t=document.querySelector(a.getAttribute('href'));
    if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
  });
});
